import { API_URL } from '../config/connect';

const getPromotions = async (params = {}) => {
    const googleIdToken = localStorage.getItem("google_id_token");

    if (!googleIdToken) {
        throw new Error("No token found. User is not signed in.");
    }

    try {
        const queryParams = new URLSearchParams();
        
        if (params.page) queryParams.append('page', params.page);
        if (params.limit) queryParams.append('limit', params.limit);
        if (params.announcement_id) queryParams.append('announcement_id', params.announcement_id);
        if (params.user_id) queryParams.append('user_id', params.user_id);
        if (params.status) queryParams.append('status', params.status); // pending, active, expired

        const endpoint = `${API_URL}/api/v1/admin/promotions?${queryParams.toString()}`;

        const response = await fetch(endpoint, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${googleIdToken}`,
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch promotions. Status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching promotions:', error);
        throw error;
    }
};

export default getPromotions;

